var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "auto"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索客户...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchSalesContract
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _vm.currentUser.superAdmin || _vm.arrayIntersection(['salesAssist'], _vm.currentUser.simpleRole).length > 0 ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.openCreateSalesContractDrawer();
      }
    }
  }, [_vm._v("新增销售合同")]) : _vm._e()], 1), _c('div', {
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tableData
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function (_ref) {
        var row = _ref.row;
        return _vm.currentUser.superAdmin || _vm.arrayIntersection(['factoryLeader', 'technologyLead', 'technology', 'allFactoryLeader'], _vm.currentUser.simpleRole).length > 0 ? [_c('Button', {
          attrs: {
            "type": "info",
            "ghost": "",
            "size": "small",
            "icon": "ios-funnel"
          },
          on: {
            "click": function ($event) {
              return _vm.$refs.RecipeDrawer.openDrawer(row);
            }
          }
        }, [_vm._v("配方")])] : undefined;
      }
    }], null, true)
  })], 1), _c('CreateSalesContractDrawer', {
    ref: "CreateSalesContractDrawer"
  }), _c('SalesContractDetailDrawer', {
    ref: "SalesContractDetailDrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }